<template lang="pug">
  .post-heading(v-if="heading || subHeading")
    h2.text-2xl.font-semibold {{ heading }}
</template>

<script>
export default {
    name: 'Heading',
    props: {
        heading: {
            type: String
        },
        subHeading: {
            type: String
        }
    }
};
</script>

<style lang="sass" scoped>
.post-heading
  margin-bottom: .5rem
  .is-primary
    color: var(--color-primary)
  h3
    margin-bottom: 0
    color: inherit
  h4
    margin-bottom: 0
    font-weight: 450
    letter-spacing: 0
</style>
